export default [
  {
    router_info: '/asset/application',
    component: (resolve) => require(['../src/views/asset/application.vue'], resolve)
  },
  {
    router_info: '/asset/assetManage',
    component: (resolve) => require(['../src/views/asset/assetManage.vue'], resolve)
  },
  {
    router_info: '/asset/group',
    component: (resolve) => require(['../src/views/asset/group_asset/index.vue'], resolve)
  },
  {
    router_info: '/asset/mine',
    component: (resolve) => require(['../src/views/asset/mine_asset.vue'], resolve)
  },
  {
    router_info: '/auth/group',
    component: (resolve) => require(['../src/views/auth/group.vue'], resolve)
  },
  {
    router_info: {path: '/auth/group_detail/:id', noChkout: true},
    component: (resolve) => require(['../src/views/auth/group_detail.vue'], resolve)
  },
  {
    router_info: '/auth/service',
    component: (resolve) => require(['../src/views/auth/service.vue'], resolve)
  },
  {
    router_info: '/auth_mis/group',
    component: (resolve) => require(['../src/views/auth_mis/group.vue'], resolve)
  },
  {
    router_info: {
                path:'/auth_mis/group_detail/:id',
                noChkout: true
            },
    component: (resolve) => require(['../src/views/auth_mis/group_detail.vue'], resolve)
  },
  {
    router_info: '/blogger/infor',
    component: (resolve) => require(['../src/views/blogger/infor/index.vue'], resolve)
  },
  {
    router_info: '/blogger/records_fin',
    component: (resolve) => require(['../src/views/blogger/records/fin.vue'], resolve)
  },
  {
    router_info: '/blogger/records',
    component: (resolve) => require(['../src/views/blogger/records/index.vue'], resolve)
  },
  {
    router_info: '/blogger/resourcelibrary/detail',
    component: (resolve) => require(['../src/views/blogger/resourcelibrary/Detail.vue'], resolve)
  },
  {
    router_info: '/blogger/resourcelibrary/detail_cj',
    component: (resolve) => require(['../src/views/blogger/resourcelibrary/Detail_cj.vue'], resolve)
  },
  {
    router_info: '/blogger/resourcelibrary/detail_k',
    component: (resolve) => require(['../src/views/blogger/resourcelibrary/Detail_k.vue'], resolve)
  },
  {
    router_info: '/blogger/examine',
    component: (resolve) => require(['../src/views/blogger/resourcelibrary/examine.vue'], resolve)
  },
  {
    router_info: '/blogger/resourcelibrary',
    component: (resolve) => require(['../src/views/blogger/resourcelibrary/index.vue'], resolve)
  },
  {
    router_info: '/blogger/sku',
    component: (resolve) => require(['../src/views/blogger/sku/index.vue'], resolve)
  },
  {
    router_info: '/blogger/transfer',
    component: (resolve) => require(['../src/views/blogger/transfer/index.vue'], resolve)
  },
  {
    router_info: '/bonus_reward/import',
    component: (resolve) => require(['../src/views/bonus_reward/import.vue'], resolve)
  },
  {
    router_info: '/business/contract',
    component: (resolve) => require(['../src/views/business/contract.vue'], resolve)
  },
  {
    router_info: '/business/contract_pending',
    component: (resolve) => require(['../src/views/business/contract_pending.vue'], resolve)
  },
  {
    router_info: '/business/mall_item',
    component: (resolve) => require(['../src/views/business/mall_item.vue'], resolve)
  },
  {
    router_info: '/business/stock',
    component: (resolve) => require(['../src/views/business/stock.vue'], resolve)
  },
  {
    router_info: '/business/stock_alert',
    component: (resolve) => require(['../src/views/business/stock_alert.vue'], resolve)
  },
  {
    router_info: '/business/stock_calc',
    component: (resolve) => require(['../src/views/business/stock_calc.vue'], resolve)
  },
  {
    router_info: '/business/stock_management',
    component: (resolve) => require(['../src/views/business/stock_management.vue'], resolve)
  },
  {
    router_info: '/common/company_desc',
    component: (resolve) => require(['../src/views/common/company_desc.vue'], resolve)
  },
  {
    router_info: '/common/find_customer',
    component: (resolve) => require(['../src/views/common/find_customer.vue'], resolve)
  },
  {
    router_info: [{path: '*',noChkout: true,}],
    component: (resolve) => require(['../src/views/common/forbidden.vue'], resolve)
  },
  {
    router_info: '/common/schoolmate',
    component: (resolve) => require(['../src/views/common/schoolmate.vue'], resolve)
  },
  {
    router_info: {path: '/common/tin',noChkout: true},
    component: (resolve) => require(['../src/views/common/taxpayer_identification_number.vue'], resolve)
  },
  {
    router_info: {path: '/common/wage_excel',noChkout: true},
    component: (resolve) => require(['../src/views/common/wage_excel.vue'], resolve)
  },
  {
    router_info: {path: '/common/warehouse',noChkout: true},
    component: (resolve) => require(['../src/views/common/warehouse.vue'], resolve)
  },
  {
    router_info: '/common/wiki',
    component: (resolve) => require(['../src/views/common/wiki.vue'], resolve)
  },
  {
    router_info: '/cost_sharing/list',
    component: (resolve) => require(['../src/views/cost_sharing/list.vue'], resolve)
  },
  {
    router_info: '/cost_sharing/subject_list',
    component: (resolve) => require(['../src/views/cost_sharing/subject_list.vue'], resolve)
  },
  {
    router_info: '/course_report/chart',
    component: (resolve) => require(['../src/views/course_report/chart.vue'], resolve)
  },
  {
    router_info: '/course_report/dashboard',
    component: (resolve) => require(['../src/views/course_report/dashboard.vue'], resolve)
  },
  {
    router_info: '/course_report/dashboard_monthly',
    component: (resolve) => require(['../src/views/course_report/dashboard_monthly.vue'], resolve)
  },
  {
    router_info: '/course_report/dashboard_term_alignment',
    component: (resolve) => require(['../src/views/course_report/dashboard_term_alignment.vue'], resolve)
  },
  {
    router_info: '/course_report/manual_input',
    component: (resolve) => require(['../src/views/course_report/manual_input.vue'], resolve)
  },
  {
    router_info: '/course_report/setting',
    component: (resolve) => require(['../src/views/course_report/setting.vue'], resolve)
  },
  {
    router_info: '/dashBoard/cashIncome',
    component: (resolve) => require(['../src/views/dashBoard/cashIncome/index.vue'], resolve)
  },
  {
    router_info: '/dashBoard/fundsmonitoring/fin/difference_statement',
    component: (resolve) => require(['../src/views/dashBoard/fundsmonitoring/accountStatement/index.vue'], resolve)
  },
  {
    router_info: '/dashBoard/fundsmonitoring/fin/difference_in_out_statement',
    component: (resolve) => require(['../src/views/dashBoard/fundsmonitoring/differenceStatement/index.vue'], resolve)
  },
  {
    router_info: '/dashBoard/fundsmonitoring/fin',
    component: (resolve) => require(['../src/views/dashBoard/fundsmonitoring/fin/index.vue'], resolve)
  },
  {
    router_info: '/dashBoard/fundsmonitoring/management',
    component: (resolve) => require(['../src/views/dashBoard/fundsmonitoring/management/index.vue'], resolve)
  },
  {
    router_info: {path: '/dashBoard/routerDetail/:id',noChkout: true},
    component: (resolve) => require(['../src/views/dashBoard/routerDetail.vue'], resolve)
  },
  {
    router_info: '/dashBoardSetting/teamProjectSetting',
    component: (resolve) => require(['../src/views/dashboardSetting/teamProjectSetting/index.vue'], resolve)
  },
  {
    router_info: '/dev/front_end',
    component: (resolve) => require(['../src/views/dev/ front_end_dev.vue'], resolve)
  },
  {
    router_info: '/dev/commit_log',
    component: (resolve) => require(['../src/views/dev/commit_log.vue'], resolve)
  },
  {
    router_info: '/dev/email_log',
    component: (resolve) => require(['../src/views/dev/email_log.vue'], resolve)
  },
  {
    router_info: '/dev/mdi_icon',
    component: (resolve) => require(['../src/views/dev/mdi_icon.vue'], resolve)
  },
  {
    router_info: '/dev/sms_log',
    component: (resolve) => require(['../src/views/dev/sms_log.vue'], resolve)
  },
  {
    router_info: {path:'/update-token', noChkout: true,justDev:true},
    component: (resolve) => require(['../src/views/dev/update_token.vue'], resolve)
  },
  {
    router_info: '/event_notice/index',
    component: (resolve) => require(['../src/views/event_notice/index.vue'], resolve)
  },
  {
    router_info: '/exec/assets/check',
    component: (resolve) => require(['../src/views/exec/asset_check.vue'], resolve)
  },
  {
    router_info: '/exec/assets/check_list/batch',
    component: (resolve) => require(['../src/views/exec/asset_check_batch_list.vue'], resolve)
  },
  {
    router_info: '/exec/assets/check_list',
    component: (resolve) => require(['../src/views/exec/asset_check_list.vue'], resolve)
  },
  {
    router_info: '/exec/asset_in_out_record',
    component: (resolve) => require(['../src/views/exec/asset_in_out_record.vue'], resolve)
  },
  {
    router_info: '/exec/asset_customer_operate',
    component: (resolve) => require(['../src/views/exec/asset_operate.vue'], resolve)
  },
  {
    router_info: '/exec/asset_rule',
    component: (resolve) => require(['../src/views/exec/asset_rule.vue'], resolve)
  },
  {
    router_info: '/exec/asset_setting',
    component: (resolve) => require(['../src/views/exec/asset_setting.vue'], resolve)
  },
  {
    router_info: '/exec/assets',
    component: (resolve) => require(['../src/views/exec/assets.vue'], resolve)
  },
  {
    router_info: '/exec/introduction',
    component: (resolve) => require(['../src/views/exec/introduction.vue'], resolve)
  },
  {
    router_info: '/exec/phone',
    component: (resolve) => require(['../src/views/exec/phone_manage/index.vue'], resolve)
  },
  {
    router_info: '/exec/travel_order',
    component: (resolve) => require(['../src/views/exec/travel_order.vue'], resolve)
  },
  {
    router_info: '/payment/records',
    component: (resolve) => require(['../src/views/expense_payment_record/records.vue'], resolve)
  },
  {
    router_info: '/payment/repay',
    component: (resolve) => require(['../src/views/expense_payment_record/repay.vue'], resolve)
  },
  {
    router_info: '/file/desktop',
    component: (resolve) => require(['../src/views/file/desktop.vue'], resolve)
  },
  {
    router_info: '/file_stamp/list',
    component: (resolve) => require(['../src/views/file_stamp/list.vue'], resolve)
  },
  {
    router_info: '/fin/account-share',
    component: (resolve) => require(['../src/views/fin/AccountShare.vue'], resolve)
  },
  {
    router_info: '/business/account/management',
    component: (resolve) => require(['../src/views/fin/account_management/TFperson.vue'], resolve)
  },
  {
    router_info: '/account/management',
    component: (resolve) => require(['../src/views/fin/account_management/index.vue'], resolve)
  },
  {
    router_info: '/fin/budget/detail',
    component: (resolve) => require(['../src/views/fin/budget/FinApplyDetail.vue'], resolve)
  },
  {
    router_info: '/fin/budget',
    component: (resolve) => require(['../src/views/fin/budget/FinView.vue'], resolve)
  },
  {
    router_info: '/mine/budget/detail',
    component: (resolve) => require(['../src/views/fin/budget/MineApplyDetail.vue'], resolve)
  },
  {
    router_info: '/mine/fin/budget',
    component: (resolve) => require(['../src/views/fin/budget/MineView.vue'], resolve)
  },
  {
    router_info: '/fin/cash_flow_type',
    component: (resolve) => require(['../src/views/fin/cash_flow_type.vue'], resolve)
  },
  {
    router_info: {path: '/fin/expense_group_print',noChkout: true},
    component: (resolve) => require(['../src/views/fin/components/expense_group_print.vue'], resolve)
  },
  {
    router_info: {path: '/fin/components/payee_company_detail',noChkout: true,},
    component: (resolve) => require(['../src/views/fin/components/payee_company_detail.vue'], resolve)
  },
  {
    router_info: '/fin/consumption_plan_bills/detail',
    component: (resolve) => require(['../src/views/fin/consumption_plan/bill.vue'], resolve)
  },
  {
    router_info: '/fin/consumption_plan',
    component: (resolve) => require(['../src/views/fin/consumption_plan/index.vue'], resolve)
  },
  {
    router_info: '/fin/contract',
    component: (resolve) => require(['../src/views/fin/contract.vue'], resolve)
  },
  {
    router_info: '/fin/contract_export',
    component: (resolve) => require(['../src/views/fin/contract_export.vue'], resolve)
  },
  {
    router_info: '/fin/contract_need_pay',
    component: (resolve) => require(['../src/views/fin/contract_need_pay.vue'], resolve)
  },
  {
    router_info: '/fin/contract_setting',
    component: (resolve) => require(['../src/views/fin/contract_setting/index.vue'], resolve)
  },
  {
    router_info: '/fin/contract_type',
    component: (resolve) => require(['../src/views/fin/contract_type.vue'], resolve)
  },
  {
    router_info: '/fin/customer_account',
    component: (resolve) => require(['../src/views/fin/customer_account.vue'], resolve)
  },
  {
    router_info: '/fin/customer_expense_type',
    component: (resolve) => require(['../src/views/fin/customer_expense_type.vue'], resolve)
  },
  {
    router_info: '/fin/expense_estimate',
    component: (resolve) => require(['../src/views/fin/expense_estimate/index.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_accrual',
    component: (resolve) => require(['../src/views/fin/expense_group_accrual.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_accrual_repair',
    component: (resolve) => require(['../src/views/fin/expense_group_accrual_repair.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_advance',
    component: (resolve) => require(['../src/views/fin/expense_group_advance.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_bill',
    component: (resolve) => require(['../src/views/fin/expense_group_bill.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_company',
    component: (resolve) => require(['../src/views/fin/expense_group_company.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_customer',
    component: (resolve) => require(['../src/views/fin/expense_group_customer.vue'], resolve)
  },
  {
    router_info: {path: '/fin/expense_group_export',noChkout: true},
    component: (resolve) => require(['../src/views/fin/expense_group_export.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_export_check',
    component: (resolve) => require(['../src/views/fin/expense_group_export_check.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_export_to_pay',
    component: (resolve) => require(['../src/views/fin/expense_group_export_to_pay.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_invoice',
    component: (resolve) => require(['../src/views/fin/expense_group_invoice.vue'], resolve)
  },
  {
    router_info: {path: '/fin/expense_group_none_cost',noChkout: true},
    component: (resolve) => require(['../src/views/fin/expense_group_none_cost.vue'], resolve)
  },
  {
    router_info: {path: '/fin/expense_group_outsource',noChkout: true},
    component: (resolve) => require(['../src/views/fin/expense_group_outsource.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_recharge',
    component: (resolve) => require(['../src/views/fin/expense_group_recharge.vue'], resolve)
  },
  {
    router_info: '/fin/expense_group_recharge_write_off',
    component: (resolve) => require(['../src/views/fin/expense_group_recharge_write_off.vue'], resolve)
  },
  {
    router_info: '/fin/expense_type',
    component: (resolve) => require(['../src/views/fin/expense_type.vue'], resolve)
  },
  {
    router_info: '/fin/informal_wage_topic',
    component: (resolve) => require(['../src/views/fin/informal_wage_topic.vue'], resolve)
  },
  {
    router_info: '/fin/informal_wage_topic_detail/:id',
    component: (resolve) => require(['../src/views/fin/informal_wage_topic_detail.vue'], resolve)
  },
  {
    router_info: '/fin/outsource_wage_topic',
    component: (resolve) => require(['../src/views/fin/outsource_wage_topic.vue'], resolve)
  },
  {
    router_info: {path: '/fin/outsource_wage_topic_detail/:id',noChkout: true},
    component: (resolve) => require(['../src/views/fin/outsource_wage_topic_detail.vue'], resolve)
  },
  {
    router_info: '/fin/payee_company',
    component: (resolve) => require(['../src/views/fin/payee_company.vue'], resolve)
  },
  {
    router_info: '/fin/process_control',
    component: (resolve) => require(['../src/views/fin/process_control/index.vue'], resolve)
  },
  {
    router_info: '/fin/recharge_write_off',
    component: (resolve) => require(['../src/views/fin/recharge_write_off.vue'], resolve)
  },
  {
    router_info: '/fin/recorded',
    component: (resolve) => require(['../src/views/fin/recorded.vue'], resolve)
  },
  {
    router_info: '/fin/rmb_central_parities',
    component: (resolve) => require(['../src/views/fin/rmb_central_parities.vue'], resolve)
  },
  {
    router_info: '/fin/salary_administration',
    component: (resolve) => require(['../src/views/fin/salaryadministration/index.vue'], resolve)
  },
  {
    router_info: '/fin/send_sms',
    component: (resolve) => require(['../src/views/fin/send_sms.vue'], resolve)
  },
  {
    router_info: '/fin/setting',
    component: (resolve) => require(['../src/views/fin/setting.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_payable_bill',
    component: (resolve) => require(['../src/views/fin_bill/fin_payable_bill.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_payment_accrual_bill',
    component: (resolve) => require(['../src/views/fin_bill/fin_payment_accrual_bill.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_payment_bill',
    component: (resolve) => require(['../src/views/fin_bill/fin_payment_bill.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_receipt_accrual_bill',
    component: (resolve) => require(['../src/views/fin_bill/fin_receipt_accrual_bill.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_receipt_bill',
    component: (resolve) => require(['../src/views/fin_bill/fin_receipt_bill.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_receivable_bill',
    component: (resolve) => require(['../src/views/fin_bill/fin_receivable_bill.vue'], resolve)
  },
  {
    router_info: '/fin_bill/fin_split_cash',
    component: (resolve) => require(['../src/views/fin_bill/fin_split_cash.vue'], resolve)
  },
  {
    router_info: {path: '/fin_report/dashboard_dynamic',noChkout: true,},
    component: (resolve) => require(['../src/views/fin_report/dashboard_dynamic.vue'], resolve)
  },
  {
    router_info: {path: '/fin_report/dashboard_dynamic_income',noChkout: true},
    component: (resolve) => require(['../src/views/fin_report/dashboard_dynamic_income.vue'], resolve)
  },
  {
    router_info: {path: '/fin_report/dashboard_monthly',noChkout: true,},
    component: (resolve) => require(['../src/views/fin_report/dashboard_monthly.vue'], resolve)
  },
  {
    router_info: {path: '/fin_report/expense_pool_management',noChkout: true},
    component: (resolve) => require(['../src/views/fin_report/expense_pool_management.vue'], resolve)
  },
  {
    router_info: '/fin_report/manual_input',
    component: (resolve) => require(['../src/views/fin_report/manual_input.vue'], resolve)
  },
  {
    router_info: {path: '/fin_report/setting/fin_team_period',noChkout: true},
    component: (resolve) => require(['../src/views/fin_report/setting/fin_team_period.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/dashboard_dynamic',
    component: (resolve) => require(['../src/views/fin_report_v2/dashboard_dynamic.vue'], resolve)
  },
  {
    router_info: {path: '/fin_report_v2/dashboard_dynamic_income',noChkout: true},
    component: (resolve) => require(['../src/views/fin_report_v2/dashboard_dynamic_income.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/dashboard_monthly',
    component: (resolve) => require(['../src/views/fin_report_v2/dashboard_monthly.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/expense_pool_management',
    component: (resolve) => require(['../src/views/fin_report_v2/expense_pool_management.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/manual_input',
    component: (resolve) => require(['../src/views/fin_report_v2/manual_input.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/setting/fin_expense_type',
    component: (resolve) => require(['../src/views/fin_report_v2/setting/fin_expense_type.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/setting/fin_team',
    component: (resolve) => require(['../src/views/fin_report_v2/setting/fin_team.vue'], resolve)
  },
  {
    router_info: '/fin_report_v2/setting/fin_team_period',
    component: (resolve) => require(['../src/views/fin_report_v2/setting/fin_team_period.vue'], resolve)
  },
  {
    router_info: '/fin_setting/wage_title_mapping',
    component: (resolve) => require(['../src/views/fin_setting/wage_title_mapping.vue'], resolve)
  },
  {
    router_info: '/fin_statement/cashBalance',
    component: (resolve) => require(['../src/views/fin_statement/cashBalance/index.vue'], resolve)
  },
  {
    router_info: '/fin_statement/cash_balance_v2',
    component: (resolve) => require(['../src/views/fin_statement/cashBalanceV2/index.vue'], resolve)
  },
  {
    router_info: '/fin_statement/config',
    component: (resolve) => require(['../src/views/fin_statement/config.vue'], resolve)
  },
  {
    router_info: '/fin_statement/list',
    component: (resolve) => require(['../src/views/fin_statement/list.vue'], resolve)
  },
  {
    router_info: {path: '/flow/edit/:id',noChkout: true},
    component: (resolve) => require(['../src/views/flow/edit.vue'], resolve)
  },
  {
    router_info: '/flow/list',
    component: (resolve) => require(['../src/views/flow/list.vue'], resolve)
  },
  {
    router_info: '/flow/states',
    component: (resolve) => require(['../src/views/flow/states.vue'], resolve)
  },
  {
    router_info: '/flow/statistics',
    component: (resolve) => require(['../src/views/flow/statistics.vue'], resolve)
  },
  {
    router_info: '/flow/transfer',
    component: (resolve) => require(['../src/views/flow/transfer.vue'], resolve)
  },
  {
    router_info: '/flow/transfer_user',
    component: (resolve) => require(['../src/views/flow/transfer_user.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/batch-flow-manage',
    component: (resolve) => require(['../src/views/hr/PaymentManage/BatchFlowManage.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/marketing-p-r',
    component: (resolve) => require(['../src/views/hr/PaymentManage/MarketingServicesPR.vue'], resolve)
  },
  {
    router_info: '/hr/notify',
    component: (resolve) => require(['../src/views/hr/PaymentManage/Notify/Notify.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/official-m',
    component: (resolve) => require(['../src/views/hr/PaymentManage/OfficialM.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/official-p-r',
    component: (resolve) => require(['../src/views/hr/PaymentManage/OfficialPR.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/pay-flow',
    component: (resolve) => require(['../src/views/hr/PaymentManage/PayFlow/index.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/payment-base',
    component: (resolve) => require(['../src/views/hr/PaymentManage/PaymentBase.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/payment-proportion',
    component: (resolve) => require(['../src/views/hr/PaymentManage/PaymentProportion.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/recurring-payment',
    component: (resolve) => require(['../src/views/hr/PaymentManage/RecurringPaymentItems.vue'], resolve)
  },
  {
    router_info: '/hr/payment-manage/subsidized-meals-set',
    component: (resolve) => require(['../src/views/hr/PaymentManage/SubsidizedMealsSet.vue'], resolve)
  },
  {
    router_info: '/hr/salary-flow/batch-adjustment',
    component: (resolve) => require(['../src/views/hr/PaymentManage/salaryFlow/BatchAdjustment.vue'], resolve)
  },
  {
    router_info: '/hr/salary-flow/single-person',
    component: (resolve) => require(['../src/views/hr/PaymentManage/salaryFlow/index.vue'], resolve)
  },
  {
    router_info: '/hr/batch_operation',
    component: (resolve) => require(['../src/views/hr/batch_operation.vue'], resolve)
  },
  {
    router_info: '/hr/company',
    component: (resolve) => require(['../src/views/hr/company.vue'], resolve)
  },
  {
    router_info: '/hr/contract_alert',
    component: (resolve) => require(['../src/views/hr/contract_alert.vue'], resolve)
  },
  {
    router_info: {path: '/hr/customer_detail/:id', noChkout: true},
    component: (resolve) => require(['../src/views/hr/customer_detail.vue'], resolve)
  },
  {
    router_info: [
      {
        path: '/hr/customer_export',
        noChkout: true
      },
      {
        path: '/fin/customer_export',
        noChkout: true
      }
    ],
    component: (resolve) => require(['../src/views/hr/customer_export.vue'], resolve)
  },
  {
    router_info: '/hr/customers',
    component: (resolve) => require(['../src/views/hr/customers.vue'], resolve)
  },
  {
    router_info: {path: '/hr/fi_wage_records/:topic_id',noChkout: true},
    component: (resolve) => require(['../src/views/hr/fi_wage_records.vue'], resolve)
  },
  {
    router_info: {path:'/hr/fi_wage_topic',noChkout: true},
    component: (resolve) => require(['../src/views/hr/fi_wage_topic.vue'], resolve)
  },
  {
    router_info: {path:'/hr/introduction',noChkout: true},
    component: (resolve) => require(['../src/views/hr/introduction.vue'], resolve)
  },
  {
    router_info: '/hr/job',
    component: (resolve) => require(['../src/views/hr/job.vue'], resolve)
  },
  {
    router_info: '/hr/material_alert',
    component: (resolve) => require(['../src/views/hr/material_alert.vue'], resolve)
  },
  {
    router_info: '/hr/pre_customer',
    component: (resolve) => require(['../src/views/hr/pre_customer.vue'], resolve)
  },
  {
    router_info: '/hr/recruit_job',
    component: (resolve) => require(['../src/views/hr/recruit_job.vue'], resolve)
  },
  {
    router_info: '/hr/schoolmate',
    component: (resolve) => require(['../src/views/hr/schoolmate.vue'], resolve)
  },
  {
    router_info: '/hr/team',
    component: (resolve) => require(['../src/views/hr/team.vue'], resolve)
  },
  {
    router_info: {path: '/iframeRouter/:id',noChkout: true},
    component: (resolve) => require(['../src/views/iframe/index.vue'], resolve)
  },
  {
    router_info: '/income_group/income_group_accrual',
    component: (resolve) => require(['../src/views/income_group/income_group_accrual.vue'], resolve)
  },
  {
    router_info: '/income_group/income_group_receipt',
    component: (resolve) => require(['../src/views/income_group/income_group_receipt.vue'], resolve)
  },
  {
    router_info: '/income_group/receipt_purpose',
    component: (resolve) => require(['../src/views/income_group/receipt_purpose.vue'], resolve)
  },
  {
    router_info: {path: '/', noChkout: true},
    component: (resolve) => require(['../src/views/index.vue'], resolve)
  },
  {
    router_info: '/invoice/clamp',
    component: (resolve) => require(['../src/views/invoice/clamp/index.vue'], resolve)
  },
  {
    router_info: '/invoice/export',
    component: (resolve) => require(['../src/views/invoice/export.vue'], resolve)
  },
  {
    router_info: '/invoice/generate',
    component: (resolve) => require(['../src/views/invoice/generate.vue'], resolve)
  },
  {
    router_info: '/invoice/index',
    component: (resolve) => require(['../src/views/invoice/index.vue'], resolve)
  },
  {
    router_info: '/invoice/no_invoice_expense/index',
    component: (resolve) => require(['../src/views/invoice/no_invoice_expense/index.vue'], resolve)
  },
  {
    router_info: '/invoice/invoice_print',
    component: (resolve) => require(['../src/views/invoice/print_invoice.vue'], resolve)
  },
  {
    router_info: '/invoice/register/expense_bx',
    component: (resolve) => require(['../src/views/invoice/register/expense_bx.vue'], resolve)
  },
  {
    router_info: '/invoice/register/expense_fk',
    component: (resolve) => require(['../src/views/invoice/register/expense_fk.vue'], resolve)
  },
  {
    router_info: '/invoice/statistic',
    component: (resolve) => require(['../src/views/invoice/statistic/index.vue'], resolve)
  },
  {
    router_info: '/subject_iteration/subject_iteration',
    component: (resolve) => require(['../src/views/invoice_setting/subject_iteration/index.vue'], resolve)
  },
  {
    router_info: '/subject_iteration/subject_map',
    component: (resolve) => require(['../src/views/invoice_setting/subject_map/index.vue'], resolve)
  },
  {
    router_info: '/kingdee_sync/list',
    component: (resolve) => require(['../src/views/kingdee_sync/list.vue'], resolve)
  },
  {
    router_info: '/kingdee_sync/out_stock',
    component: (resolve) => require(['../src/views/kingdee_sync/out_stock.vue'], resolve)
  },
  {
    router_info: '/legal_affairs/certification_audit',
    component: (resolve) => require(['../src/views/legal_affairs/certification_audit_list.vue'], resolve)
  },
  {
    router_info: '/legal_affairs/certification_manage',
    component: (resolve) => require(['../src/views/legal_affairs/certification_manage/index.vue'], resolve)
  },
  {
    router_info: '/legal_affairs/person_certification_audit',
    component: (resolve) => require(['../src/views/legal_affairs/person_certification_audit_list.vue'], resolve)
  },
  {
    router_info: '/mine/info',
    component: (resolve) => require(['../src/views/mine/customer_detail.vue'], resolve)
  },
  {
    router_info: {path: '/mine/expense', noChkout: true},
    component: (resolve) => require(['../src/views/mine/expense.vue'], resolve)
  },
  {
    router_info: '/mine/expense_accrual',
    component: (resolve) => require(['../src/views/mine/expense_group_accrual.vue'], resolve)
  },
  {
    router_info: '/mine/expense_accrual_repair',
    component: (resolve) => require(['../src/views/mine/expense_group_accrual_repair.vue'], resolve)
  },
  {
    router_info: '/mine/expense_advance',
    component: (resolve) => require(['../src/views/mine/expense_group_advance.vue'], resolve)
  },
  {
    router_info: '/mine/expense_group_bill',
    component: (resolve) => require(['../src/views/mine/expense_group_bill.vue'], resolve)
  },
  {
    router_info: '/mine/expense_group_company',
    component: (resolve) => require(['../src/views/mine/expense_group_company.vue'], resolve)
  },
  {
    router_info: '/mine/expense_group_customer',
    component: (resolve) => require(['../src/views/mine/expense_group_customer.vue'], resolve)
  },
  {
    router_info: '/mine/expense_group_invoice',
    component: (resolve) => require(['../src/views/mine/expense_group_invoice.vue'], resolve)
  },
  {
    router_info: '/mine/expense_group_none_cost',
    component: (resolve) => require(['../src/views/mine/expense_group_none_cost.vue'], resolve)
  },
  {
    router_info: '/mine/expense_recharge',
    component: (resolve) => require(['../src/views/mine/expense_group_recharge.vue'], resolve)
  },
  {
    router_info: '/mine/expense_recharge_write_off',
    component: (resolve) => require(['../src/views/mine/expense_group_recharge_write_off.vue'], resolve)
  },
  {
    router_info: '/mine/introduction',
    component: (resolve) => require(['../src/views/mine/introduction.vue'], resolve)
  },
  {
    router_info: '/mine/options',
    component: (resolve) => require(['../src/views/mine/options.vue'], resolve)
  },
  {
    router_info: '/mine/profile',
    component: (resolve) => require(['../src/views/mine/profile.vue'], resolve)
  },
  {
    router_info: '/notice/send',
    component: (resolve) => require(['../src/views/notices/send.vue'], resolve)
  },
  {
    router_info: '/offline/order/apply',
    component: (resolve) => require(['../src/views/offline/order/apply.vue'], resolve)
  },
  {
    router_info: '/set_up_shop/check',
    component: (resolve) => require(['../src/views/openShopApply/check.vue'], resolve)
  },
  {
    router_info: '/set_up_shop/apply',
    component: (resolve) => require(['../src/views/openShopApply/index.vue'], resolve)
  },
  {
    router_info: '/set_up_shop/thrid_shop',
    component: (resolve) => require(['../src/views/openShopApply/thridShop.vue'], resolve)
  },
  {
    router_info: '/option/import',
    component: (resolve) => require(['../src/views/option/import.vue'], resolve)
  },
  {
    router_info: '/option/management',
    component: (resolve) => require(['../src/views/option/management.vue'], resolve)
  },
  {
    router_info: '/other/office_map',
    component: (resolve) => require(['../src/views/other/office_map.vue'], resolve)
  },
  {
    router_info: '/outsource/contract',
    component: (resolve) => require(['../src/views/outsource/contract.vue'], resolve)
  },
  {
    router_info: '/outsource/my_contract',
    component: (resolve) => require(['../src/views/outsource/my_contract.vue'], resolve)
  },
  {
    router_info: '/rec_award/list',
    component: (resolve) => require(['../src/views/rec_award/list.vue'], resolve)
  },
  {
    router_info: '/recruit/my_recruit',
    component: (resolve) => require(['../src/views/recruit/my_recruit.vue'], resolve)
  },
  {
    router_info: '/recruit/recruit',
    component: (resolve) => require(['../src/views/recruit/recruit.vue'], resolve)
  },
  {
    router_info: '/refund_offline/refund_offline_apply',
    component: (resolve) => require(['../src/views/refund_offline/refund_offline_apply.vue'], resolve)
  },
  {
    router_info: '/resell/resell_order',
    component: (resolve) => require(['../src/views/resell/resell_order.vue'], resolve)
  },
  {
    router_info: '/resell/resell_order_fin',
    component: (resolve) => require(['../src/views/resell/resell_order_fin.vue'], resolve)
  },
  {
    router_info: '/resell/settlement/settlement_order',
    component: (resolve) => require(['../src/views/resell/settlement/settlement_order.vue'], resolve)
  },
  {
    router_info: '/resell/settlement/settlement_order_fin',
    component: (resolve) => require(['../src/views/resell/settlement/settlement_order_fin.vue'], resolve)
  },
  {
    router_info: '/reservation/travel_order',
    component: (resolve) => require(['../src/views/reservation/travel_order.vue'], resolve)
  },
  {
    router_info: ['/resource/export','/resource/hrExport'],
    component: (resolve) => require(['../src/views/resource/export.vue'], resolve)
  },
  {
    router_info: '/router_manage/groupManage/detailEdit',
    component: (resolve) => require(['../src/views/routerManage/groupManage/detailEdit/index.vue'], resolve)
  },
  {
    router_info: '/router_manage/groupManage',
    component: (resolve) => require(['../src/views/routerManage/groupManage/index.vue'], resolve)
  },
  {
    router_info: '/router_manage/edit/app_router_manage',
    component: (resolve) => require(['../src/views/routerManage/routerEdit/appRouterManage/index.vue'], resolve)
  },
  {
    router_info: '/router_manage/edit',
    component: (resolve) => require(['../src/views/routerManage/routerEdit/index.vue'], resolve)
  },
  {
    router_info: {path: '/rule/edit/:id',noChkout: true},
    component: (resolve) => require(['../src/views/rule/edit.vue'], resolve)
  },
  {
    router_info: {path:'/rule/list',noChkout: true},
    component: (resolve) => require(['../src/views/rule/list.vue'], resolve)
  },
  {
    router_info: '/spu/config',
    component: (resolve) => require(['../src/views/spu_manage/spu_config/index.vue'], resolve)
  },
  {
    router_info: '/spu/list',
    component: (resolve) => require(['../src/views/spu_manage/spu_list/index.vue'], resolve)
  },
  {
    router_info: '/stock/contract_stock',
    component: (resolve) => require(['../src/views/stock/contract_stock.vue'], resolve)
  },
  {
    router_info: '/stock/list',
    component: (resolve) => require(['../src/views/stock/list.vue'], resolve)
  },
  {
    router_info: '/stock/order',
    component: (resolve) => require(['../src/views/stock/order.vue'], resolve)
  },
  {
    router_info: '/stock/period_cost',
    component: (resolve) => require(['../src/views/stock/period_cost.vue'], resolve)
  },
  {
    router_info: '/stock/product_type',
    component: (resolve) => require(['../src/views/stock/product_type.vue'], resolve)
  },
  {
    router_info: '/stock/shop',
    component: (resolve) => require(['../src/views/stock/shop.vue'], resolve)
  },
  {
    router_info: '/stock/stock_in',
    component: (resolve) => require(['../src/views/stock/stock_in.vue'], resolve)
  },
  {
    router_info: '/stock/stock_in_print',
    component: (resolve) => require(['../src/views/stock/stock_in_print.vue'], resolve)
  },
  {
    router_info: '/stock/tax_code',
    component: (resolve) => require(['../src/views/stock/tax_code.vue'], resolve)
  },
  {
    router_info: '/stock/warehouse',
    component: (resolve) => require(['../src/views/stock/warehouse.vue'], resolve)
  },
  {
    router_info: '/stock_online/item',
    component: (resolve) => require(['../src/views/stock_online/item.vue'], resolve)
  },
  {
    router_info: '/team/informal_wage_audit',
    component: (resolve) => require(['../src/views/team/informal_wage_audit.vue'], resolve)
  },
  {
    router_info: '/team/dimission_informal_wage_audit',
    component: (resolve) => require(['../src/views/team/informal_wage_lz.vue'], resolve)
  },
  {
    router_info: '/team/my_informal_customer',
    component: (resolve) => require(['../src/views/team/my_informal_customer.vue'], resolve)
  },
  {
    router_info: {path: '/team/my_informal_wage_record/:id',noChkout: true},
    component: (resolve) => require(['../src/views/team/my_informal_wage_record.vue'], resolve)
  },
  {
    router_info: '/team/my_outsource_customer',
    component: (resolve) => require(['../src/views/team/my_outsource_customer.vue'], resolve)
  },
  {
    router_info: {path: '/team/my_outsource_wage_record/:id',noChkout: true},
    component: (resolve) => require(['../src/views/team/my_outsource_wage_record.vue'], resolve)
  },
  {
    router_info: '/team/outsource_wage_audit',
    component: (resolve) => require(['../src/views/team/outsource_wage_audit.vue'], resolve)
  },
  {
    router_info: {path: '/team/team_informal_wage_topic',noChkout: true},
    component: (resolve) => require(['../src/views/team/team_informal_wage_topic.vue'], resolve)
  },
  {
    router_info: {path: '/team/team_informal_wage_topic_detail/:id',noChkout: true},
    component: (resolve) => require(['../src/views/team/team_informal_wage_topic_detail.vue'], resolve)
  },
  {
    router_info: {path: '/team/team_outsource_wage_topic',noChkout: true},
    component: (resolve) => require(['../src/views/team/team_outsource_wage_topic.vue'], resolve)
  },
  {
    router_info: {path:'/team/team_outsource_wage_topic_detail/:id',noChkout: true},
    component: (resolve) => require(['../src/views/team/team_outsource_wage_topic_detail.vue'], resolve)
  },
  {
    router_info: {path: '/team/team_tree',noChkout: true},
    component: (resolve) => require(['../src/views/team/team_tree.vue'], resolve)
  },
  {
    router_info: '/team_fin_customer/list',
    component: (resolve) => require(['../src/views/team_fin_customer/list.vue'], resolve)
  },
  {
    router_info: '/wage/my_record',
    component: (resolve) => require(['../src/views/wage/my_record.vue'], resolve)
  },
  {
    router_info: '/wage/social_record',
    component: (resolve) => require(['../src/views/wage/social_record.vue'], resolve)
  },
  {
    router_info: '/wage/wage_comment',
    component: (resolve) => require(['../src/views/wage/wage_comment.vue'], resolve)
  },
  {
    router_info: '/wage/wage_record',
    component: (resolve) => require(['../src/views/wage/wage_record.vue'], resolve)
  },
  {
    router_info: '/wage_title_mapping/list',
    component: (resolve) => require(['../src/views/wage_title_mapping/list.vue'], resolve)
  },
  {
    router_info: '/wage_title_mapping/list_new',
    component: (resolve) => require(['../src/views/wage_title_mapping/new/index.vue'], resolve)
  }
]